import { render, staticRenderFns } from "./DeliveryResult.vue?vue&type=template&id=68e7f961&scoped=true&"
import script from "./DeliveryResult.vue?vue&type=script&lang=js&"
export * from "./DeliveryResult.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryResult.vue?vue&type=style&index=0&id=68e7f961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7f961",
  null
  
)

export default component.exports